import { render, staticRenderFns } from "./headerimg.vue?vue&type=template&id=5960965e&scoped=true"
import script from "./headerimg.vue?vue&type=script&lang=js"
export * from "./headerimg.vue?vue&type=script&lang=js"
import style0 from "./headerimg.vue?vue&type=style&index=0&id=5960965e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960965e",
  null
  
)

export default component.exports